<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.aroma.update")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineReferentialForm
        :model="model"
        :item="item"
        resource="aromas"
        entity="aromas"
        group-field="family"
        :group-label="$t('intranet.referential.attributes.family')"
        :APIbaseURL="APIbaseURL"
      />
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular indeterminate :size="100" :width="10" color="secondary"></v-progress-circular>
    </div>
  </div>
</template>

<script>
import AveineReferentialForm from '@/components/AveineReferentialForm.vue'
import Aroma from '@/store/models/aroma'
import { errorHandler } from 'aveine-toolbox'

export default {
  name: 'Update',
  components: { AveineReferentialForm },
  data () {
    return {
      model: Aroma,
      item: {},
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  async created () {
    try {
      await Aroma.api().get(
        `aromas/${this.$route.params.id}?lang=${this.$i18n.locale}`,
        { baseURL: this.APIbaseURL }
      )
      this.item = await Aroma.query().whereId(this.$route.params.id).first()
      if (!this.item.name) this.item.name = {}
      this.dataLoaded = true
    } catch (errors) {
      this.dataLoaded = true
      errorHandler(errors, this)
    }
  }
}
</script>
